import React, { useContext, useEffect, useState } from "react";
import CategoriesList from "../components/Admin/Categories/CategoriesList";
import Wrapper from "../components/Common/Wrapper";
import { AuthContext } from "../context/Auth";
import { gteCategories } from "./../services/adminCategoriesService";

function HomeLoggedIn() {
  const { authState } = useContext(AuthContext);
  const [categories, setCategories] = useState([]);

  const fetchCategoriesList = async () => {
    const { data, status } = await gteCategories(authState.token);

    if (status === 200) {
      setCategories(data.data);
    }
  };

  useEffect(() => {
    fetchCategoriesList();
  }, []);

  return (
    <Wrapper wrapperClass="home-wrapper">
      <div className="m-t-h">
        <CategoriesList categories={categories} />
      </div>
    </Wrapper>
  );
}

export default HomeLoggedIn;
